export default __webpack_public_path__ + "static/media/graph.61ffd82a.svg";